
const bannersStyle = theme => ({

  
  banner: {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    marginTop: "0",
    height: "200px"
  },
  
});

export default bannersStyle;
